import React from "react";
import { Link } from 'react-router-dom'
import Button from '@material-ui/core/Button';

class LinkButton extends React.Component {
    renderLink = itemProps => <Link to={this.props.to} {...itemProps}/>;

    render() {
        const { text, variant, size, color } = this.props;

        return (
            <Button variant={variant} size={size} color={color} component={this.renderLink}>{text}</Button>
        )
    }
}

export default LinkButton;